module.exports = __webpack_public_path__ + "static/media/docUpload.a426f8e5.svg";